// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__qhluJ","icon":"Skill_icon__qYo4U","img":"Skill_img__ALyQN","title":"Skill_title__Hv+a-"};